export enum DatasetAccessLevel {
  OWNER = "owner",
  ANALYST = "analyze",
  PREVIEW = "preview",
}

export enum TableAccessLevel {
  READ = "read",
  WRITE = "write",
}

export const roleActionsMap: Record<DatasetAccessLevel, string[]> = {
  analyze: [],
  owner: [
    "create:catalog-file",
    "create:catalog-ingest",
    "create:catalog-report",
    "delete:catalog-dataset",
    "edit:catalog-file",
    "edit:catalog-metadata",
    "edit:catalog-report",
  ],
  preview: [],
};
